import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import classNames from 'classnames';

import generalStyles from './style/general.module.css';

export default class FadingBackground extends Component {
  constructor() {
    super();

    this.handleScroll = throttle(this.handleScroll.bind(this), 10, {
      trailing: true,
      leading: false,
    });

    this.scrollOpacity = 1;
    this.fadingBackground = null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;
    const wH = windowHeight / 3;
    const scrollFraction = scrollY / wH;
    const newOpacity = 1 - scrollFraction;

    if (newOpacity >= 0) {
      this.scrollOpacity = newOpacity;
    } else {
      this.scrollOpacity = 0;
    }

    this.fadingBackground.style.opacity = this.scrollOpacity;
  }

  render() {
    const { backgroundColor } = this.props;

    const fadingBackgroundClassName = classNames(
      generalStyles.fadingBackground,
      backgroundColor
    );

    const fadingBackgroundProps = {
      className: fadingBackgroundClassName,
      ref: ref => {
        this.fadingBackground = ref;
      },
    };

    return <div {...fadingBackgroundProps} />;
  }
}

FadingBackground.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/commons/FadingBackground/index.js